import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import '../theme/edit-profile.scss';

const NavbarGlobal = ({ title, showBackButton = false, customButtons = [] }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="glass-navbar">
      <span className="glass-navbar__title">{title}</span>
      <div className="glass-navbar__actions">
        {showBackButton && (
          <button className="btn" onClick={() => navigate(-1)}>
            Volver
          </button>
        )}
        
        {isMobile && customButtons.length > 0 ? (
          <Dropdown className="ms-2">
            <Dropdown.Toggle variant="primary" id="dropdown-actions">
              Acciones
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {customButtons.map((button, index) => (
                <Dropdown.Item 
                  key={index} 
                  onClick={button.onClick}
                  className="dropdown-item-custom"
                >
                  {button.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          customButtons.map((button, index) => (
            <button
              key={index}
              className={`btn ms-2${button.variant ? ` btn-${button.variant}` : ''}`}
              onClick={button.onClick}
            >
              {button.label}
            </button>
          ))
        )}
      </div>
    </div>
  );
};

// PropTypes para la validación de las props
NavbarGlobal.propTypes = {
  title: PropTypes.string.isRequired,
  showBackButton: PropTypes.bool,
  customButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      variant: PropTypes.string, // Opcional para el estilo del botón
    })
  ),
};

export default NavbarGlobal;
